import { Injectable } from '@angular/core';
import { BRAND } from '../brand/brand';

const STORAGE_KEY = `${BRAND.storagePrefix}.deviceId`;

/**
 * Stable per-install id so the API can tell a phone and a laptop apart
 * from two people sharing one account.
 */
@Injectable({ providedIn: 'root' })
export class DeviceIdService {
  private cached: string | null = null;

  getId(): string {
    if (this.cached) {
      return this.cached;
    }
    let existing: string | null = null;
    try {
      existing = localStorage.getItem(STORAGE_KEY);
    } catch {
      existing = null;
    }
    if (!existing || !/^[A-Za-z0-9._-]{8,64}$/.test(existing)) {
      existing = this.createId();
      try {
        localStorage.setItem(STORAGE_KEY, existing);
      } catch {
        /* private mode: keep it in memory for this tab */
      }
    }
    this.cached = existing;
    return existing;
  }

  headerName(): string {
    return 'X-QTrainer-Device';
  }

  private createId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    const bytes = new Uint8Array(16);
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      crypto.getRandomValues(bytes);
    } else {
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
}
